// Variaveis globais
var iconSet = 'fa';

// Verificando qual é a página
$(document).ready(function () {
    dataScreen = $('body').data('screen');
});


function clean_data(obj) {
    for (var key in obj) {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "" || obj[key] === " ") {
            delete obj[key];
        }
        if (typeof obj[key] === 'object' && Object.keys(obj[key]).length <= 0) {
            delete obj[key];
        }
        if (typeof obj[key] === 'object') {
            clean_data(obj[key]);
        }
    }
    return obj;
}

/**
 * Inicializa a máscara para R$
 *
 * @param seletor
 * @param options
 * @returns {boolean}
 */
function initMaskMoney(seletor, options) {
    if (typeof seletor === 'object') {
        options = seletor;
        seletor = undefined;
    }
    seletor = seletor || '.mask-money';

    if ($(seletor).length) {
        $(seletor).maskMoney(options || {thousands: '.', decimal: ',', allowZero: true, prefix: ''});
    }

    return true;
}


/**
 * Inicializa as máscaras utilizadas nos campos dos formulários
 */
function initMasks() {

    initMaskMoney();

    var maskCep = $(".mask-cep");
    if (maskCep.length) {
        maskCep.mask("00000-000", {clearIfNotMatch: true});
    }

    var maskCpf = $(".mask-cpf");
    if (maskCpf.length) {
        maskCpf.mask("000.000.000-00", {clearIfNotMatch: true});
    }

    var maskCnpj = $(".mask-cnpj");
    if (maskCnpj.length) {
        maskCnpj.mask("00.000.000/0000-00", {clearIfNotMatch: true});
    }

    var maskDate = $(".mask-date");
    if (maskDate.length) {
        maskDate.mask("00/00/0000", {clearIfNotMatch: true});
    }

    var maskYear = $(".mask-year");
    if (maskYear.length) {
        maskYear.mask("0000", {clearIfNotMatch: true});
    }

    var maskMonth = $(".mask-mes");
    if (maskMonth.length) {
        maskMonth.mask("00", {clearIfNotMatch: true});
    }

    var maskCodeCard = $(".mask-security-code-card");
    if (maskCodeCard.length) {
        var maskSecurityCodeCard = function (val) {
            return val.replace(/\D/g, '').length === 11 ? '000' : '0009';
        };
        var maskSecurityCodeCardOptions = {
            onKeyPress: function (val, e, field, options) {
                field.mask(maskSecurityCodeCard.apply({}, arguments), options);
            }
        };

        maskCodeCard.mask(maskSecurityCodeCard, maskSecurityCodeCardOptions);
    }

    var maskPhone = $(".mask-tel");
    if (maskPhone.length) {
        var maskTel = function (val) {
            return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
        };
        var maskTelOptions = {
            onKeyPress: function (val, e, field, options) {
                field.mask(maskTel.apply({}, arguments), options);
            }
        };

        maskPhone.mask(maskTel, maskTelOptions);
    }
}

/**
 * Inicializa o mmenu (menu mobile)
 * @param mobileVersions
 */
function initMenuMobile(mobileVersions) {
    if (mobileVersions.indexOf(dataScreen) > -1) {

        $('nav#menu').removeClass('hidden').mmenu({
            extensions: ["shadow-panels", "fx-panels-slide-100", "border-none",  "fullscreen"],
            setSelected: true,
            onClick: {
                blockUI: true
            },
            navbars     : {
                content : [ "prev", "close" ],
            },
        });

        var menu = $("nav#menu").data( "mmenu" );

        $(".menu-close").click(function() {
            menu.close();
        });
    }
}


/**
 *
 * Grid or List | 3 4 6 Columns Controller
 *
 */

function getOptionsAvailable()
{
    var optionsAvailable = [];
    $('[data-products-visualization]:visible').each(function(i, element) {
        optionsAvailable.push(String($(element).data('products-visualization')));
    });

    return optionsAvailable;
}

function gridOrList()
{
    var $body = $('body');

    if ($body.data('page') == 'home') {
        return;
    }

    if (window.parameter.mostrar_menu_colunas != 'true') {
        return;
    }

    var allClasses = ['columns-3', 'columns-4', 'columns-5', 'columns-6'];

    var list    = '.product-list:not(.cross-selling-container):not(.product-list-carousel)',
        product = list + ' .product';

    $('[data-products-visualization]').removeClass('active');
    $('[data-products-visualization="' + $.cookie('products-visualization') + '"]').addClass('active');

    $(list).removeClass(allClasses.join(" ")).addClass($.cookie('products-visualization'));

    switch ($.cookie('products-visualization')) {

        case 'columns-3':

            $(product).removeClass('col-lg-2 col-lg-2-10 col-lg-3 col-lg-4').addClass('col-lg-4');
            $(product).removeClass('col-xl-2 col-xl-2-10 col-xl-3 col-xl-4').addClass('col-xl-4');

            break;

        case 'columns-4':

            $(product).removeClass('col-lg-2 col-lg-2-10 col-lg-3 col-lg-4').addClass('col-lg-3');
            $(product).removeClass('col-xl-2 col-xl-2-10 col-xl-3 col-xl-4').addClass('col-xl-3');

            break;

        case 'columns-5':

            $(product).removeClass('col-lg-2 col-lg-2-10 col-lg-3 col-lg-4').addClass('col-lg-2-10');
            $(product).removeClass('col-xl-2 col-xl-2-10 col-xl-3 col-xl-4').addClass('col-xl-2-10');

            break;

        case 'columns-6':

            $(product).removeClass('col-lg-2 col-lg-2-10 col-lg-3 col-lg-4').addClass('col-lg-2');
            $(product).removeClass('col-xl-2 col-xl-2-10 col-xl-3 col-xl-4').addClass('col-xl-2');

            break;
    }

    resetColumn();

    setTimeout(function() {
        buttonAviseme();
        initLazyLoad();
    }, 200);
}

function changeCookieGridOrList()
{
    var $body = $('body');

    // Verifica se é possível alterar a quantidade de colunas por linha:
    var podeMudar = window.parameter.mostrar_menu_colunas;

    // Verifica se a opção atual está disponível
    var opcaoEstaDisponivel = $.inArray($.cookie('products-visualization'), getOptionsAvailable()) >= 0;

    if (!podeMudar) {
        $.cookie('products-visualization', $body.data('columns-default'), {expire: 30, path: '/'});
    } else {
        if (!opcaoEstaDisponivel) {
            $.cookie('products-visualization', getOptionsAvailable().slice(-1)[0], {expire: 30, path: '/'});
        }
    }

    gridOrList();
}



// ------------------------------------------------------

// Input number
function initTouchSpin() {
    $(".touch-spin").each(function () {
        $(this).TouchSpin({
            min: $(this).attr('min') ? $(this).attr('min') : 0,
            max: $(this).attr('max') ? $(this).attr('max') : 9999999,
            stepinterval: 50,
            maxboostedstep: 10000000,
            buttondown_txt: '<i class="fa fa-minus-circle"></i>',
            buttonup_txt: '<i class="fa fa-plus-circle"></i>',
            buttondown_class: 'btn',
            buttonup_class: 'btn'
        });
    });
}

function initFormDataActions() {

    $('body').on('click', 'a[data-action="delete"]', function (e) {

        e.preventDefault();

        var _this = this;

        var form = false;
        var urlLocation = false;

        if ($(this).data('form') && $(this).data('type') == 'submit') {
            form = $($(this).data('form'));
        } else {
            urlLocation = $(this).attr('href');
        }

        var options = {
            title: $(this).data('title') ? $(this).data('title') : 'Você tem certeza?',
            text: $(this).data('text') ? $(this).data('text') : "Você realmente deseja remover esta informação?",
            type: "warning",
            showCancelButton: true,

            confirmButtonClass: "btn-success",
            cancelButtonClass: "btn-danger",

            confirmButtonText: "Sim",
            cancelButtonText: "Não"
        };

        swal(options, function (isConfirm) {
            if (isConfirm) {
                loadOnDisabledElement(_this);
                if (form) {
                    form.trigger('submit');
                } else {
                    window.location = urlLocation;
                }
            }
        });
    });
}

// Abrindo e fechando menu mobile

// Lightbox
function initLightbox(seletor, options) {
    initMagnificPopupModal();
    return true;
}

// Validando HTML5
function validity(seletor, message) {
    $(seletor).on('change', function () {
        try {
            this.setCustomValidity('');
        } catch (e) {
        }
    });

    $(seletor).on('invalid', function () {
        this.setCustomValidity(message);
    });
}

// Disable load
function loadOnDisabledElement(element) {
    if ($(element).length) {
        $(element)
            .attr('disabled', true);

        $(element).addClass('btn-progress');

        // if ($(element).find('.fa').length > 0) {
        //     $(element).find('.fa').remove();
        //     $(element).prepend(iconLoading());
        // } else {
        //     if ($(element).find('.fa-spinner').length == 0) {
        //         $(element).prepend(iconLoading());
        //     }
        // }
    }
}

function iconLoading() {
    return '<i class="fa fa-spin fa-spinner"></i> ';
}

// Remove o svg do button ou link
function removeLoaderFromElement(element) {
    $(element).each(function (i, el) {
        if ($(el).is('form')) {
            $(el).find('[type="submit"]').find('.fa-spinner').remove();
        } else {
            $(element).find('.fa-spinner').remove();
        }
    });
}

//  Desabilita o botão de submit quando tenta enviar o formulário
function disableFormOnSubmit() {

    $('form.form-disabled-on-load').submit(function () {
        loadOnDisabledElement($(this).find('[type="submit"]'));
    });

    $('a.form-disabled-on-load,.btn-spinner').click(function () {
        loadOnDisabledElement(this);
    });
}

// Verifica qual o tipo de cartão de crédito
function validateCreditCard() {

    $('.input-credit-card').validateCreditCard(function (result) {
        var input = document.getElementById('number-card-sp'),
            securityInput = $('#security-code-sp');

        if (result.card_type != null) {
            var cartName = result.card_type.name;
            var space_regex = /\s/g;
            var lengthInput = $(input).val().replace(space_regex, "").length;

            if (lengthInput >= 6) {
                $(input).css('background-image', 'url(' + window.root_path + '/img/icons/' + cartName + '-32.png)');
                $('#flag-card').val(cartName);
            } else {
                $(input).css('background-image', 'none');
                $('#flag-card').val('');
            }

            if (result.card_type.mask_number) {
                var backup = $(input).val();
                $(input).val('').mask(result.card_type.mask_number).val(backup);
            } else {
                $(input).mask('0000000000000000');
            }

            $(securityInput).mask(result.card_type.mask_security);

            

            if (lengthInput != result.card_type.valid_length) {
                input.setCustomValidity('Número do cartão inválido.');
            } else {
                input.setCustomValidity('');
            }
        } else {
            $(input).css('background-image', 'none');
            //$(input).next('span').attr('class', '');
            $('#flag-card').val('');
            $(input).mask('0000000000000000');
            $(securityInput).val('');
        }


    }, {
        accept: ['amex', 'diners', 'discover', 'elo', 'mastercard', 'visa', 'hipercard']
    })
}

// Recarrega o conteudo
function reloadContent() {
    $('body').load(window.location.href + ' .update-onload');
}

/*
 Mostra o botão de comprar fixo quando o botão de comprar normal não aparece na tela
 Usado no mobile nos detalhes do produto.
 */
function showBuyButton() {
}

/* Select com links (direciona após o change)
 * */
function selectWithLinks(seletor) {
    if (!seletor) {
        seletor = '.select-with-links';
    }

    if ($(seletor).length) {
        $(seletor).bind('change', function () {
            var url = $(this).val();
            if (url) {
                window.location = url;
            }
            return false;
        });
    }
}

// Busca sugestiva
function suggestiveSearch() {
    var $inputSearch = $("#suggestive-search-input");
    if ($inputSearch.length > 0) {
        $inputSearch.autocomplete({
            appendTo: '#suggestive-search',
            source: root_path + '/busca/search/',
            focus: function (event, ui) {
                $inputSearch.val(ui.item.name);
                return false;
            },
            select: function (event, ui) {
                window.location = ui.item.url;
                return false;
            },
            minChars: 3,
            messages: {
                noResults: '',
                results: function () {
                }
            }
        }).data("autocomplete")._renderItem = function (ul, item) {
            return $("<li></li>")
                .data("item.autocomplete", item)
                .append(item.html)
                .appendTo(ul);
        };
    }
}

/**
 * Função que carrega as cidades com base no id do estado.
 *
 * @param estado_id ID do estado que deseja carregar as cidades
 * @param target DIV na qual será carregado o elemento select
 * @param defaultValue Nome da cidade na qual virá selecionada
 * @param callback
 */
function loadCidades(estado_id, target, defaultValue, callback) {
    callback = callback || function() {};
    if (estado_id) {
        $.ajax({
            url: window.root_path + '/ajax/ajax-cidades.php',
            data: {estadoId: estado_id, cidade: defaultValue},
            beforeSend: function () {
                target.html('<select class="form-control"><option>Carregando...</option></select>');
            },
            success: function (response) {
                target.html(response);
                callback();
            }
        });
    } else {
        target.html('<select class="form-control"><option>Cidade</option></select>');
    }

}

/**
 * Função que carrega os dados de endereço com base no CEP
 *
 * @param string cep
 * @param object fields Deve conter o mapeamento dos objetos a serem atualizados
 */
function loadEndereco(cep, fields) {

    // Limpa o CEP deixando apenas os dígitos
    cep = cep.replace(/\D/g, '');

    // Passa os campos em variáveis
    var $field_cep = fields.cep
        , $field_endereco = fields.endereco
        , $field_complemento = fields.complemento
        , $field_bairro = fields.bairro
        , $field_estado = fields.estado
        , $field_cidade = fields.cidade
        , $field_numero = fields.numero;

    if (/[0-9]{8}/.test(cep)) {

        $.ajax({
            url: window.root_path + '/ajax/consulta-endereco/?cep=' + cep,
            dataType: 'json',
            beforeSend: function () {

                $field_cep.parent()
                    .css('position', 'relative');

                $('<svg class="loader cep-loading" xml:space="preserve" style="enable-background:new 0 0 50 50;" viewBox="0 0 50 50" height="34px" width="34px" y="0px" x="0px">' +
                    '<path d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z" fill="#000">' +
                    '<animateTransform repeatCount="indefinite" dur="0.6s" to="360 25 25" from="0 25 25" type="rotate" attributeName="transform" attributeType="xml">' +
                    '</path>' +
                    '</svg> Aguarde...')
                    .css({
                        position: 'absolute',
                        top: '10px',
                        right: '10px'
                    })
                    .insertAfter($field_cep);

                // Endereço
                $field_endereco.attr('disabled', true);
                $field_complemento.attr('disabled', true);
                $field_bairro.attr('disabled', true);
                $field_estado.attr('disabled', true);
                $field_cidade.attr('disabled', true);

            },
            success: function (response) {

                if (typeof response == 'object' && response != null) {

                    $field_endereco.val(response.logradouro);
                    $field_endereco.attr('disabled', response.logradouro.length > 0);

                    $field_complemento.val(response.complemento);
                    $field_complemento.removeAttr('disabled');

                    $field_bairro.val(response.bairro);
                    $field_bairro.attr('disabled', response.bairro.length > 0);

                    var estadoId = $field_estado.find('option[data-sigla="' + response.uf + '"]').val();
                    $field_estado.attr('disabled', response.uf.length > 0);

                    if (estadoId) {
                        $field_estado.val(estadoId);
                        var parentCity = $field_cidade.parent();
                        loadCidades(estadoId, parentCity, response.cidade, function() {
                            parentCity.find('select').attr('disabled', response.cidade.length > 0);
                        });
                    }

                    if ($(':focus').length == 0) {
                        // Adiciona o focus no endereço se vier vazio
                        if ($field_endereco.val() == '') {
                            $field_endereco.focus();
                            return;
                        }

                        // Adiciona o focus no bairro se vier vazio
                        if ($field_bairro.val() == '') {
                            $field_bairro.focus();
                            return;
                        }

                        // Adiciona o focus no campo número
                        $field_numero.focus();
                    }

                    return;
                }

                // Se der algum erro, limpa todos os campos e dá o foco no campo de endereço
                $field_endereco.val('').removeAttr('disabled');
                $field_numero.val('').removeAttr('disabled');
                $field_complemento.val('').removeAttr('disabled');
                $field_bairro.val('').removeAttr('disabled');
                $field_estado.val('').removeAttr('disabled');
                $field_cidade.val('').removeAttr('disabled');

                $field_endereco.focus();

                showNotify({
                    title: 'Não foi possível carregar as informações do CEP.',
                    text: "Continue o cadastro preenchendo as suas informações manualmente.",
                })
            },
            error: function() {
                // Se der algum erro, limpa todos os campos e dá o foco no campo de endereço
                $field_endereco.val('').removeAttr('disabled');
                $field_numero.val('').removeAttr('disabled');
                $field_complemento.val('').removeAttr('disabled');
                $field_bairro.val('').removeAttr('disabled');
                $field_estado.val('').removeAttr('disabled');
                $field_cidade.val('').removeAttr('disabled');
            },
            complete: function () {
                $('.cep-loading').fadeOut(function () {
                    $(this).remove();
                });
                $field_endereco.closest('form').find('.row.hide').removeClass('hide');
            }
        });

    } else {
        showNotify({
            title: 'O CEP informado é inválido.',
            text: "Por favor, informe um CEP válido."
        });
    }
}

function initPicture() {
    picturefill();
}

function initRating() {
    $('.rating').rating().on('rating.change', function (event, value, caption) {
        $(this).attr('value', value);
        $('.rating-title').attr('value', window.starRate[value]);
    });
}

function initFormFilterProduct() {
    $(".form-filter select").on("change", function (event) {
        PNotify.removeAll();
        new PNotify({
            addclass: 'qp-pnotify theme-brand',
            text: '<i class="fa fa-spin fa-spinner"></i> Carregando...',
            type: 'info'
        });
        $('.form-filter').submit();
    });
    $(".form-filter").on("submit", function (event) {
        event.preventDefault();
        var separator = window.location.href.indexOf('?') == -1 ? '?' : '&';
        $('.container-product-list').load(window.location.href + separator + $(this).serialize() + ' .product-list ', function () {
            initRating();
            initPicture();
            initLazyLoad();
            if ($('.btn-open-quickview').length > 0) {
                hoverProduto();
            }
            changeCookieGridOrList();
            $(this).append('<div class="main-quick-view"></div>');
            PNotify.removeAll();
        });
    });
}

function svgLoader(width) {
    return '<svg class="loader" xml:space="preserve" style="enable-background:new 0 0 50 50;" viewBox="0 0 50 50" y="0px" x="0px">' +
        '<path d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z" fill="#fff">' +
        '<animateTransform repeatCount="indefinite" dur="0.6s" to="360 25 25" from="0 25 25" type="rotate" attributeName="transform" attributeType="xml">' +
        '</path>' +
        '</svg>';
}

function resizeIframe(iframe) {
    $('.mfp-content i.fa').remove();
    iframe.height = iframe.contentWindow.document.body.scrollHeight + 30;

    $(iframe).animate({
        opacity: 1,
    }, 500);
}

function openMagnificPopupIframe(url) {



    var markupStyle =
        // '@media (max-width: 991px) { ' +
        // '.mfp-iframe-holder, .mfp-iframe-scaler { padding: 0; } .mfp-iframe-holder .mfp-content {max-width: 100%; max-height: 100%; height:100%} ' +
        // '} ' +
        // '.mfp-iframe-holder .mfp-content { max-width: 992px; height:100% } ' +
        // '.mfp-iframe-scaler { padding: 0; } ' +
        '.mfp-content iframe {opacity: 0} ' +
        '.mfp-content i.fa { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); } ';

    // Adiciona um parametro identificando que é um iframe (conflito de schemas)
    url = addParameterOnUrl(url, 'iframe', 1);

    $.magnificPopup.open({
        items: {
            src: url
        },
        tLoading: 'Carregando...',
        type: 'iframe',
        mainClass: 'initial-popup',
        iframe: {
            patterns: {
                youtube: {
                    index: 'youtube.com/',
                    id: function (url) {
                        var m = url.match(/[\\?\\&]v=([^\\?\\&]+)/);
                        if (!m || !m[1]) return null;
                        return m[1];
                    },
                    src: '//www.youtube.com/embed/%id%?autoplay=1'
                },
                vimeo: {
                    index: 'vimeo.com/',
                    id: function (url) {
                        var m = url.match(/(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/);
                        if (!m || !m[5]) return null;
                        return m[5];
                    },
                    src: '//player.vimeo.com/video/%id%?autoplay=1'
                }
            },
            srcAction: 'iframe_src',
            markup: '<style>' + markupStyle + '</style>' +
            '<i class="fa fa-spinner fa-spin fa-4x"></i>' +
            '<div class="mfp-iframe-scaler" >' +
            '<div class="mfp-close"></div>' +
            '<iframe onload="resizeIframe(this)" class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
            '</div>'
        }
    }, 0);
}

function initMagnificPopupModal() {
    $('body').on('click', '[data-lightbox*="iframe"]', function (e) {
        e.preventDefault();
        if ($(this).is('a')) {
            openMagnificPopupIframe($(this).attr('href'));
        } else {
            if ($(this).data('href')) {
                openMagnificPopupIframe($(this).data('href'));
            }
        }
    });
}
$(function() {

    $('.mfp-modal-header').on('click', '.mfp-close', function() {
        parent.$('.mfp-close').trigger('click');
    });

    $(document).on('click', '.popup-modal-dismiss', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });
})

function initPreventClickOnDropdownMenu() {
    $('body').on('click', '.dropdown-menu', function(e) {
        var target = $(e.target);
        if (target.is('a') == false)
        {
            e.preventDefault();
            return false;
        }
    });
}

function initSlimScroll() {
    $('.slimScroll').each(function() {
        var height = $(this).data('height');
        if (height > 0 == false) {
            height = 250;
        }
        $(this).slimScroll({
            height: height + 'px'
        });
    });

    initPreventClickOnDropdownMenu();
}

function loadCartQuantity() {

    var urlAjax = window.root_path + '/ajax/cart.quantity';
    $.ajax({
        url: urlAjax,
        contentType: "application/json; charset=utf-8",
        cache: false,
        success: function(response) {
            var content = JSON.parse(response);
            $('.cart-quantity').html(content.subtotal_html);
            $('.quantity-item').html(content.count);
        }
    });

    if (window.parent.$('.dropdown-carrinho').length > 0) {
        window.parent.$('.dropdown-carrinho').load(window.root_path + '/ajax/cart.dropdown.content');
    }
}


/**
 * Adiciona ou altera um parametro na url
 *
 * @param _baseUrl  Url que deve-se adicionar/alterar o parâmetro
 * @param name      Nome do parâmetro
 * @param value     Valor do parâmetro
 *
 * @returns String  Url com o parâmetro adicionado/alterado.
 */
function addParameterOnUrl(_baseUrl, name, value) {

    var regex = new RegExp("([?&]" + name + "=)[^&]+", "");

    function add(sep) {
        _baseUrl += sep + name + "=" + encodeURIComponent(value);
    }

    function change() {
        _baseUrl = _baseUrl.replace(regex, "$1" + encodeURIComponent(value));
    }

    if (_baseUrl.indexOf("?") === -1) {
        add("?");
    } else {
        if (regex.test(_baseUrl)) {
            change();
        } else {
            add("&");
        }
    }

    return _baseUrl;

}

function initBannerCarrinho() {
    $("#banner-carrinho").owlCarousel({
        pagination: false,
        navigation: false,
        slideSpeed: 300,
        paginationSpeed: 400,
        singleItem: true,
        autoPlay: true,
        lazyLoad: true,
    });
}

function initBannerBlocksHome() {
    var selectorElements = '.owl-caroussel-uid-galeria-arquivo';
    var $elements = $(selectorElements);
    var itemsMobile = 1;

    $elements.each(function (i, element) {
        var items = $(element).find('.item');
        items.css('margin', 'auto 7px');

        var countImages = $(element).find('.item').length;
        if (countImages >= 4) {
            itemsMobile = 2
        } else {
            itemsMobile = 1
        }
        $(element).owlCarousel({
            items: items.length,
            autoPlay: true,
            lazyLoad: true,
            itemsDesktop: [1920, items.length],
            itemsDesktopSmall: [991, items.length],
            itemsTablet: [768, itemsMobile],
            itemsMobile: [479, itemsMobile]
        });
    });
}


function hideLoader() {
    $('body').css('cursor', 'default');
    $('#modalLoadingContent').fadeOut('normal', function () {
        $(this).removeClass('show');
    });
}

function showLoader() {
    $('body').css('cursor', 'wait');
    $('#modalLoadingContent').addClass('show').fadeIn('normal');
}

function ajustCartMenu() {
    var $carrinhoHover = $('#menu-desktop .carrinho-hover');
    if ($carrinhoHover.length > 0) {
        var $navDesktop = $('#menu-desktop nav');
        var $navbarDesktop = $('#menu-desktop .navbar-nav');
        var cartWidth = $carrinhoHover.outerWidth() + 15;
        var menuWidth = $navDesktop.outerWidth();
        $navbarDesktop.css('width', (menuWidth - cartWidth)+'px');
    }
}

function ajustmentMenu() {

    ajustCartMenu();

    var $menuDesktop = $('#menu-desktop');
    var $menuDesktopNav = $menuDesktop.find('nav');
    var $menuDesktopUl = $menuDesktop.find('.nav');
    var $menuDesktopLiFirstLevel = $menuDesktopUl.find('li.dropdown');

    // -80 por conta do detalhe do menu. 40px pra cada lado de espaço adicional
    var maxWidthMenu = $menuDesktopNav.outerWidth() - 80;
    var hasMenuJustifyClass = $menuDesktop.hasClass('menu-justify');

    //$menuDesktopLiFirstLevel.addClass('hide');
    if (hasMenuJustifyClass) {
        $menuDesktop.removeClass('menu-justify');
    }

    var actualWidthMenu = 0;
    var $menuExtra = $menuDesktopUl.find('li.extra');
    if ($menuExtra.length > 0) {
        //$menuExtra.removeClass('hide');
        actualWidthMenu = $menuExtra.outerWidth();
    }
    
    console.log({'max': maxWidthMenu});
    console.log({'actualWidthMenu': actualWidthMenu});


    var removeHideClass = [];
    $menuDesktopLiFirstLevel.each(function (i, element) {

        if ($(element).hasClass('extra')) {
            return true;
        }


        // hack for get width :(
        //$(element).addClass('removeHideClass');
        $(element).removeClass('hide');
        actualWidthMenu += $(element).outerWidth();
        console.log({'add': $(element).outerWidth(), 'actualWidthMenu': actualWidthMenu});
        if (actualWidthMenu > maxWidthMenu) {
            $(element).addClass('hide');
            return true;
        }

        return true;
    });

    if (hasMenuJustifyClass) {
        console.log('1');
        $menuDesktop.addClass('menu-justify');
        // var flexArea = actualWidthMenu + ($menuDesktopLiFirstLevel.length * 15);
        // if ($menuDesktopUl.find('li.dropdown.main.hide:not(.removeHideClass)').length == 0 && flexArea <= maxWidthMenu){
        //     $menuDesktop.addClass('menu-justify');
        // }
    }

    $('.removeHideClass').removeClass('hide removeHideClass');

}

function heightMenu() {
    /**
     * A altura é controlada pelo CSS.
     */

    // var heightNav       = Math.max($('#menu-desktop').height(), 48);
    // var allLiDropdown   = $('#menu-desktop nav ul li.dropdown');
    //
    // var newHeight = heightNav + 'px';
    //
    // allLiDropdown.css('height', newHeight);
    // allLiDropdown.find('.second-level').css('top', newHeight);
    // allLiDropdown.find('a').css('height', '100%');
    //
    // if ($('.carrinho-hover')) {
    //     $('.carrinho-hover').css({
    //         'min-height': newHeight,
    //         'line-height': (heightNav - 14) / 2 + 'px'
    //     });
    //     $('.header-logo_centralizado .carrinho-hover .dropdown-carrinho').css('top', newHeight);
    // }
}

function menuIcone() {

    var menuDesktop = $('#menu-desktop');

    var allLiDropdown = $('#menu-desktop li.dropdown');

    allLiDropdown.each(function (i, element) {

        var link = $(element).find('> a');
        var img = link.find('img');

        if ($(img)) {

            var data = img.data('position');

            if (data !== undefined) {

                link.addClass('icon-' + data);

                switch (data) {
                    case 'top':
                    case 'bottom':
                        menuDesktop.css('height', '65px');
                        $(element).css('min-width', '100px');
                        break;

                    case 'left':
                    case 'right':
                        break;
                }
            }
        }
    });

    heightMenu();
    ajustmentMenu();
}

function buttonAviseme() {
    var btnAviseMe = $('button.avise-me');
    if (btnAviseMe.length) {
        var containerAviseMe = btnAviseMe.closest('.product-info');

        if (containerAviseMe.width() > 250) {
            btnAviseMe.html('<i class="fa fa-envelope-o"></i> Avise-me quando disponível');
        } else {
            btnAviseMe.html('<i class="fa fa-envelope-o"></i> Avise-me');
        }
    }
}

function showNotify(options) {

    var defaultOptions = {
        delay: 3500,
        addclass: "stack-modal",
        cornerclass: "",
        width: "350",
    };

    options = $.extend({}, defaultOptions, options);

    new window.parent.PNotify(options);
}

function showNotifySuccess(options) {

    var defaultOptions = {
        delay: 2000,
        type: 'success',
        icon: 'fa fa-check-circle'
    };

    options = $.extend({}, defaultOptions, options);

    showNotify(options);
}

function initLazyLoad() {

    $(".carousel-products .b-lazy").removeClass('b-lazy').addClass('lazyOwl');

    var bLazy = new Blazy({
        success: function () {
            bLazy.revalidate();
        }
    });
    setTimeout(function () {
        bLazy.revalidate()
    }, 150);
}

function isValidCpf(cpf) {
    cpf = cpf.replace(/[^\d]+/g, '');
    var numeros, digitos, soma, i, resultado, digitos_iguais;
    digitos_iguais = 1;
    if (cpf.length < 11)
        return false;
    for (i = 0; i < cpf.length - 1; i++)
        if (cpf.charAt(i) != cpf.charAt(i + 1)) {
            digitos_iguais = 0;
            break;
        }
    if (!digitos_iguais) {
        numeros = cpf.substring(0, 9);
        digitos = cpf.substring(9);
        soma = 0;
        for (i = 10; i > 1; i--)
            soma += numeros.charAt(10 - i) * i;
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0))
            return false;
        numeros = cpf.substring(0, 10);
        soma = 0;
        for (i = 11; i > 1; i--)
            soma += numeros.charAt(11 - i) * i;
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1))
            return false;
        return true;
    }
    else
        return false;
}

function isValidCnpj(cnpj) {

    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj == '') return false;

    if (cnpj.length != 14)
        return false;

    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999")
        return false;

    // Valida DVs
    tamanho = cnpj.length - 2;
    numeros = cnpj.substring(0, tamanho);
    digitos = cnpj.substring(tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
        return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
        return false;

    return true;
}


function renderFlashMessagesNotify(type) {
    type = type || 'all';

    $.get(window.root_path + '/ajax/flash-messages/?return=true&type=' + type, function(messages) {
        if (messages.length > 0) {
            $(messages).each(function() {
                this.type = this.type === 'danger' ? 'error' : this.type;
                showNotify({
                    type: this.type,
                    text: this.message
                });
            });
        }
    });
}

$(function() {

    $('body').on('submit', '.form-ajax-adicionar-ao-carrinho', function(e) {
        e.preventDefault();

        var $formAdicionarAoCarrinhoAjax = $(this);

        // Busca o elemento novamente, pois ele pode ter sido carregado e a variável perde a referência do botão.
        var $submitBtn = $formAdicionarAoCarrinhoAjax.find('[type=submit]');
        $submitBtn.addClass('btn-progress').prop('disabled', true);

        var isValid = false;
        var formData = $formAdicionarAoCarrinhoAjax.serialize();

        $.ajax({
            url: window.root_path + '/produtos/actions/validate-quantity-products',
            data: formData
        }).done(function (response) {
            isValid = response.status == "success";
            if (isValid) {
                var isSuccess = false;
                $.ajax({
                    url: $formAdicionarAoCarrinhoAjax.attr('action'),
                    type: 'POST',
                    data: formData
                }).done(function (response) {
                    isSuccess = response.status == "success";
                    $submitBtn.removeClass('btn-progress').prop('disabled', false);

                    if (isSuccess) {
                        if ($('.cd-quick-view').length > 0) {
                            closeQuickView(800, 900);
                        }
                        showNotifySuccess({text: 'Produtos adicionados com sucesso!'});
                        window.parent.loadCartQuantity();
                        window.parent.$.magnificPopup.close();
                        $formAdicionarAoCarrinhoAjax.trigger('reset');
                    }
                }).fail(function(){
                    showNotify({
                        type: 'error',
                        text: 'Não foi possível adicionar o item ao carrinho. Por favor, recarregue a página.'
                    });
                });
            } else {
                $submitBtn.removeClass('btn-progress').prop('disabled', false);
            }
            renderFlashMessagesNotify();
        }).fail(function(){
            showNotify({
                type: 'error',
                text: 'Não foi possível adicionar o item ao carrinho. Por favor, recarregue a página.'
            });
        });
    });
});

function formAjaxAdicionarAoCarrinho(forms) {
//     forms.each(function (i, formAdicionarAoCarrinhoAjax) {
//         // $.each($('.form-ajax-adicionar-ao-carrinho'), function(i, formAdicionarAoCarrinhoAjax) {
//
//         var $formAdicionarAoCarrinhoAjax = $(formAdicionarAoCarrinhoAjax);
//
//         if ($formAdicionarAoCarrinhoAjax.data('modal') == 'true') {
//             $('.box-exibir-grade').hide();
//         }
//
//         $formAdicionarAoCarrinhoAjax.submit(function (e) {
//
//             e.preventDefault();
//
//             // Busca o elemento novamente, pois ele pode ter sido carregado e a variável perde a referência do botão.
//             var $submitBtn = $formAdicionarAoCarrinhoAjax.find('[type=submit]');
//             var backupValue = $submitBtn.html();
//             $submitBtn.html(loadingHtml);
//             $submitBtn.prop('disabled', true);
//
//             var isValid = false;
//
//             var formData = $formAdicionarAoCarrinhoAjax.serialize();
//
//             $.ajax({
//                 url: window.root_path + '/produtos/actions/validate-quantity-products',
//                 data: formData
//             }).done(function (response) {
//                 isValid = response.status == "success";
//                 if (isValid == false) {
//                     $submitBtn.html(backupValue);
//                     $submitBtn.prop('disabled', false);
//                     if ($formAdicionarAoCarrinhoAjax.find('.quick-view-flash-messages').length) {
//                         renderFlashMessagesNotify();
//                     } else {
//                         $('.box-flash-messages').load(window.root_path + '/ajax/flash-messages');
//                     }
//                 } else {
//                     var isSuccess = false;
//                     $.ajax({
//                         url: $formAdicionarAoCarrinhoAjax.attr('action'),
//                         type: 'POST',
//                         data: formData
//                     }).done(function (response) {
//                         isSuccess = response.status == "success";
//                         $submitBtn.html(backupValue);
//                         $submitBtn.prop('disabled', false);
//                         if (isSuccess) {
//                             loadCartQuantity();
//                             showNotifySuccess({text: 'Produtos adicionados com sucesso!'});
//                             window.parent.$.magnificPopup.close();
//                             renderFlashMessagesNotify();
//                         } else {
//                             if ($formAdicionarAoCarrinhoAjax.find('.quick-view-flash-messages').length) {
//                                 renderFlashMessagesNotify();
//                             } else {
//                                 $('.box-flash-messages').load(window.root_path + '/ajax/flash-messages');
//                             }
//                         }
//                     });
//                 }
//             });
//         });
//     });
}

var changeIconColor = (function () {
    var canvas = document.createElement("canvas"), // shared instance
        context = canvas.getContext("2d");

    // set image pixel size and hex color
    color           = rgb2hex($('.first-level .color-hover').css('color'));
    colorOriginal   = rgb2hex($('.first-level a.icon-top').css('color'));
    canvas.width    = 32;
    canvas.height   = 32;

    function desaturate() {
        var imageData = context.getImageData(0, 0, canvas.width, canvas.height),
            pixels = imageData.data,
            i, l, r, g, b, a, average;

        for (i = 0, l = pixels.length; i < l; i += 4) {
            a = pixels[i + 3];
            if (a === 0) {
                continue;
            } // skip if pixel is transparent

            r = pixels[i];
            g = pixels[i + 1];
            b = pixels[i + 2];

            average = (r + g + b) / 3 >>> 0; // quick floor
            pixels[i] = pixels[i + 1] = pixels[i + 2] = average;
        }

        context.putImageData(imageData, 0, 0);
    }

    function colorize(color, alpha) {
        context.globalCompositeOperation = "source-atop";
        context.globalAlpha = alpha;
        context.fillStyle = color;
        context.fillRect(0, 0, canvas.width, canvas.height);
        // reset
        context.globalCompositeOperation = "source-over";
        context.globalAlpha = 1.0;
    }

    return function (iconElement, color, alpha) {
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(iconElement, 0, 0, canvas.width, canvas.height);
        desaturate();
        colorize(color, alpha);
        return canvas.toDataURL("image/png", 1);
    };

}());


function alteraCor(elemento) {
    $('.iconsCategorias', elemento).each(function () {
        if (!$(this).hasClass('fa')) {
            this.src = changeIconColor(this, color, '1');
        }
    })
};

function corPadrao(elemento) {
    $('.iconsCategorias', elemento).each( function () {
        if (!$(this).hasClass('fa')) {
            this.src = changeIconColor(this, colorOriginal, '1');
        }

    })
};

function rgb2hex(rgb) {
    if (!rgb) {
        return '';
    }
    if (  rgb.search("rgb") == -1 ) {
        return rgb;
    } else {
        rgb = rgb.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+))?\)$/);
        function hex(x) {
            return ("0" + parseInt(x).toString(16)).slice(-2);
        }
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
}

function updateCartQuantity() {

    $('.dropdown-carrinho-content').on('change', '.product-qtd', function() {
        // Como é necessários dois inputs, ele altera o valor dos dois inputs quando um muda
        var form         = $(this).parents('form'),
            action       = form.attr('action'),
            data         = form.serialize();

        clearTimeout(window.reloadTimer);
        window.reloadTimer = setTimeout(function() {
            $.post(action, data, function() {
                loadCartQuantity();
                renderFlashMessagesNotify();
            });
        }, 50);
    });
}

function finalizarOrcamento(obj) {
    var _this = obj;

    var form = false;
    var urlLocation = false;

    if ($(_this).data('form') && $(_this).data('type') == 'submit') {
        form = $($(_this).data('form'));
    } else {
        urlLocation = $(_this).data('href');
    }
    var options = {
        title: $(_this).data('title'),
        text: $(_this).data('text'),
        type: "warning",
        showCancelButton: true,

        confirmButtonClass: "btn-success col-xs-4 col-xs-offset-1",
        cancelButtonClass: "btn-danger col-xs-4 col-xs-offset-1",

        confirmButtonText: "SIM",
        cancelButtonText: "NÃO"
    };

    swal(options, function (isConfirm) {
        if (isConfirm) {
            loadOnDisabledElement(_this);
            if (form) {
                form.trigger('submit');
            } else {
                window.location = urlLocation;
            }
        }
    });
};

function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    var expires = "; expires=" + date.toGMTString();
    document.cookie = name + "=" + value + expires + ";path=/";
}

function getParam(p) {
    var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

function readCookie(name) {
    var n = name + "=";
    var cookie = document.cookie.split(';');
    for(var i=0;i < cookie.length;i++) {
        var c = cookie[i];
        while (c.charAt(0)==' '){c = c.substring(1,c.length);}
        if (c.indexOf(n) == 0){return c.substring(n.length,c.length);}
    }
    return null;
}

function initAdwordsForm() {
    var parameterName = window.adwords.parameterName;
    var parameterValue = getParam(parameterName);

    if (parameterValue) {
        var gclsrc = getParam('gclsrc');
        if (!gclsrc || gclsrc.indexOf('aw') !== -1) {
            setCookie(parameterName, parameterValue, 90);
        }
    }

    parameterValue = readCookie(parameterName);
    if (parameterValue != null) {
        $('form').each(function () {
            $('<input>').attr({
                type: 'hidden',
                name: 'CODIGO_ADWORDS',
                value: parameterValue
            }).appendTo($(this));
        });
    }
}